import {GlobalstarCollectorDbReader, PaymentMessages} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public GlobalstarCollectorDbReader: GlobalstarCollectorDbReader,
    public PaymentMessages: PaymentMessages,
  ) {}
}